/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 20:12:35
* @Last Modified by:   Bolt
* @Last Modified time: 2016-12-21 20:13:02
*/

'use strict';

import './amy-or-betty.less';



// WEBPACK FOOTER //
// ./src/modules/article/amy-or-betty.js